"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleBoolean = exports.handleRange = exports.handleDate = exports.handleDateRange = exports.handleTime = exports.isTime = exports.isDateRange = exports.isDate = exports.isRange = exports.isBool = void 0;
var hasProperties = function (obj, props) {
    return typeof obj === 'object' && props.every(function (prop) { return prop in obj; });
};
var isBool = function (obj) { return typeof obj === 'boolean'; };
exports.isBool = isBool;
var isRange = function (obj) { return hasProperties(obj, ['start', 'end']); };
exports.isRange = isRange;
var isDate = function (obj) { return hasProperties(obj, ['year', 'month', 'day']); };
exports.isDate = isDate;
var isDateRange = function (obj) { return hasProperties(obj, ['start', 'end']) && (0, exports.isDate)(obj.start) && (0, exports.isDate)(obj.end); };
exports.isDateRange = isDateRange;
var isTime = function (obj) { return hasProperties(obj, ['hour', 'minute', 'second']); };
exports.isTime = isTime;
/**
 * Handler functions to generate `omegaElement` strings based on the type of data received.
 * Different handlers are used depending on the type of component.
 */
// For Time components (e.g., Timefield)
var handleTime = function (elementName, time) { return "".concat(elementName, " [").concat(time.hour, "_").concat(time.minute, "_").concat(time.second, "]"); };
exports.handleTime = handleTime;
// For Date Range components (e.g., DateRangePicker)
var handleDateRange = function (elementName, range) { return "".concat(elementName, " [").concat(range.start.year, "_").concat(range.start.month, "_").concat(range.start.day, ",").concat(range.end.year, "_").concat(range.end.month, "_").concat(range.end.day, "]"); };
exports.handleDateRange = handleDateRange;
// For Date components (e.g., Calendar, DatePicker)
var handleDate = function (elementName, date) { return "".concat(elementName, " [").concat(date.year, "_").concat(date.month, "_").concat(date.day, "]"); };
exports.handleDate = handleDate;
// For Range components (e.g., RangeSlider)
var handleRange = function (elementName, range) { return "".concat(elementName, " [").concat(range.start, ",").concat(range.end, "]"); };
exports.handleRange = handleRange;
// For Boolean components (e.g., Checkbox, Switch)
var handleBoolean = function (elementName, bool) { return bool ? "".concat(elementName, " [selected]") : "".concat(elementName, " [deselected]"); };
exports.handleBoolean = handleBoolean;
